export const UPLOAD_MAX_FILE_SIZE_MB = 8;

export const UPLOAD_SUPPORTED_MIME_TYPES = ['*'];
